import { ChipSelectProps } from 'components/ChipSelect/ChipSelect'

export enum CampaignType {
  Multichannel = 'multichannel',
  Planning = 'planning',
}

export enum ChannelType {
  AbandonedCart = 'abandoned_cart',
  AboutUs = 'about_us',
  AmazonAds = 'amazon_ads',
  BattleCard = 'battle_card',
  BillingAndPayments = 'billing_and_payments',
  BingAds = 'bing_ads',
  BlogIdeas = 'blog_ideas',
  BlogPost = 'blog_post',
  CallScript = 'call_script',
  CandidateNurtureSequence = 'candidate_nurture_sequence',
  CareInstructions = 'care_instructions',
  CaseStudy = 'case_study',
  ColdOutboundEmailSequence = 'cold_outbound_email_sequence',
  DidntSignUp = 'didnt_sign_up',
  FacebookAds = 'facebook_ads',
  FacebookPost = 'facebook_post',
  FAQs = 'faqs',
  GoogleAds = 'google_ads',
  HelpDocs = 'help_docs',
  Impact = 'impact',
  InstagramPosts = 'instagram_posts',
  InstagramCaptions = 'instagram_captions',
  InstagramReel = 'instagram_reel_script',
  JobDescription = 'job_description',
  LandingPage = 'landing_page',
  LinkedInAds = 'linkedin_ads',
  LinkedInPosts = 'linkedin_posts',
  LostCustomer = 'lost_customer',
  Mission = 'mission',
  Newsletter = 'newsletter',
  NewsletterIdeas = 'newsletter_ideas',
  NurtureEmailSequence = 'nurture_email_sequence',
  OnePager = 'one_pager',
  PaymentConfirmation = 'payment_confirmation',
  PinterestAds = 'pinterest_ads',
  PreCallChecklist = 'pre_call_checklist',
  PressRelease = 'press_release',
  Pricing = 'pricing',
  ProductDemo = 'product_demo',
  ProductLaunchAmazon = 'product_launch_amazon',
  ProductLaunchEtsy = 'product_launch_etsy',
  ProductLaunchGoogle = 'product_launch_google',
  ProductLaunchShopify = 'product_launch_shopify',
  ProductLaunchWebsite = 'product_launch_website',
  PromotionalEmailSequence = 'promotional_email_sequence',
  ReplyTemplates = 'reply_templates',
  Research = 'research',
  ReturnPolicy = 'return_policy',
  ShippingPolicy = 'shipping_policy',
  SMSMessages = 'sms_messages',
  Testimonial = 'testimonial',
  TikTokAds = 'tiktok_ads',
  TikTokScript = 'tiktok_script',
  Tweets = 'tweets',
  TweetThread = 'twitter_thread',
  WarmOutboundEmailSequence = 'warm_outbound_email_sequence',
  WelcomeSeries = 'welcome_series',
  YoutubeAds = 'youtube_ads',
  YoutubeScript = 'youtube_script',
}

export interface ChannelSelectProps extends Omit<ChipSelectProps, 'children' | 'deletable' | 'onSelectionChange'> {
  onSelectionChange: (selection: Set<ChannelType>) => any
}
